/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetRoomingPerDaysSuccessfulActionPayload,
  GetRoomingPerDayByIdActionPayload,
  GetRoomingPerDayByIdSuccessfulActionPayload,
  GetActiveRoomingPerDayWithRelationsByIdActionPayload,
  GetActiveRoomingPerDayByIdWithRelationsSuccessfulActionPayload,
  CreateRoomingPerDayActionPayload,
  CreateRoomingPerDaySuccessfulActionPayload,
  UpdateRoomingPerDayActionPayload,
  UpdateRoomingPerDaySuccessfulActionPayload,
  DeleteRoomingPerDayActionPayload,
  DeleteRoomingPerDaySuccessfulActionPayload,
} from 'src/app/features/shared/models/event/rooming-per-day-data-store';

/* action types */
export enum ActionTypes {
  GetRoomingPerDays = '[ROOMINGPERDAY] GetRoomingPerDays',
  GetRoomingPerDaysSuccessful = '[ROOMINGPERDAY] GetRoomingPerDaysSuccessful',
  GetRoomingPerDaysFailure = '[ROOMINGPERDAY] GetRoomingPerDaysFailure',
  GetRoomingPerDayById = '[ROOMINGPERDAY] GetRoomingPerDayById',
  GetRoomingPerDayByIdSuccessful = '[ROOMINGPERDAY] GetRoomingPerDayByIdSuccessful',
  GetRoomingPerDayByIdFailure = '[ROOMINGPERDAY] GetRoomingPerDayByIdFailure',
  GetActiveRoomingPerDayWithRelationsById = '[ROOMINGPERDAY] GetActiveRoomingPerDayWithRelationsById',
  GetActiveRoomingPerDayByIdWithRelationsSuccessful = '[ROOMINGPERDAY] GetActiveRoomingPerDayByIdWithRelationsSuccessful',
  GetActiveRoomingPerDayByIdWithRelationsFailure = '[ROOMINGPERDAY] GetActiveRoomingPerDayByIdWithRelationsFailure',
  CreateRoomingPerDay = '[ROOMINGPERDAY] CreateRoomingPerDay',
  CreateRoomingPerDaySuccessful = '[ROOMINGPERDAY] CreateRoomingPerDaySuccessful',
  CreateRoomingPerDayFailure = '[ROOMINGPERDAY] CreateRoomingPerDayFailure',
  UpdateRoomingPerDay = '[ROOMINGPERDAY] UpdateRoomingPerDay',
  UpdateRoomingPerDaySuccessful = '[ROOMINGPERDAY] UpdateRoomingPerDaySuccessful',
  UpdateRoomingPerDayFailure = '[ROOMINGPERDAY] UpdateRoomingPerDayFailure',
  DeleteRoomingPerDay = '[ROOMINGPERDAY] DeleteRoomingPerDay',
  DeleteRoomingPerDaySuccessful = '[ROOMINGPERDAY] DeleteRoomingPerDaySuccessful',
  DeleteRoomingPerDayFailure = '[ROOMINGPERDAY] DeleteRoomingPerDayFailure',
  ResetState = '[ROOMINGPERDAY] ResetState',
}

/* actions */

/* This event gets the all RoomingPerDays. */
export const GetRoomingPerDays = createAction(ActionTypes.GetRoomingPerDays);

/* This event is fired after getting all the RoomingPerDays successfully. */
export const GetRoomingPerDaysSuccessful = createAction(
  ActionTypes.GetRoomingPerDaysSuccessful,
  props<{ payload: GetRoomingPerDaysSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the RoomingPerDays. */
export const GetRoomingPerDaysFailure = createAction(
  ActionTypes.GetRoomingPerDaysFailure,
);

/* This event gets the RoomingPerDay by RoomingPerDay id. */
export const GetRoomingPerDayById = createAction(
  ActionTypes.GetRoomingPerDayById,
  props<{ payload: GetRoomingPerDayByIdActionPayload }>(),
);

/* This event is fired after getting RoomingPerDay by RoomingPerDay id successfully. */
export const GetRoomingPerDayByIdSuccessful = createAction(
  ActionTypes.GetRoomingPerDayByIdSuccessful,
  props<{ payload: GetRoomingPerDayByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the RoomingPerDay by RoomingPerDay id. */
export const GetRoomingPerDayByIdFailure = createAction(
  ActionTypes.GetRoomingPerDayByIdFailure,
);

/* This event gets the active RoomingPerDay by RoomingPerDay id. */
export const GetActiveRoomingPerDayWithRelationsById = createAction(
  ActionTypes.GetActiveRoomingPerDayWithRelationsById,
  props<{ payload: GetActiveRoomingPerDayWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting RoomingPerDay by RoomingPerDay id successfully. */
export const GetActiveRoomingPerDayByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveRoomingPerDayByIdWithRelationsSuccessful,
  props<{
    payload: GetActiveRoomingPerDayByIdWithRelationsSuccessfulActionPayload;
  }>(),
);

/* This event is fired after couldn't get the RoomingPerDay by RoomingPerDay id. */
export const GetActiveRoomingPerDayByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveRoomingPerDayByIdWithRelationsFailure,
);

/* This event creates a RoomingPerDay. */
export const CreateRoomingPerDay = createAction(
  ActionTypes.CreateRoomingPerDay,
  props<{ payload: CreateRoomingPerDayActionPayload }>(),
);

/* This event is fired after creating a RoomingPerDay successfully. */
export const CreateRoomingPerDaySuccessful = createAction(
  ActionTypes.CreateRoomingPerDaySuccessful,
  props<{ payload: CreateRoomingPerDaySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a RoomingPerDay successfully. */
export const CreateRoomingPerDayFailure = createAction(
  ActionTypes.CreateRoomingPerDayFailure,
);

/* This event updates a RoomingPerDay. */
export const UpdateRoomingPerDay = createAction(
  ActionTypes.UpdateRoomingPerDay,
  props<{ payload: UpdateRoomingPerDayActionPayload }>(),
);

/* This event is fired after updating a RoomingPerDay successfully. */
export const UpdateRoomingPerDaySuccessful = createAction(
  ActionTypes.UpdateRoomingPerDaySuccessful,
  props<{ payload: UpdateRoomingPerDaySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a RoomingPerDay successfully. */
export const UpdateRoomingPerDayFailure = createAction(
  ActionTypes.UpdateRoomingPerDayFailure,
);

/* This event deletes a RoomingPerDay. */
export const DeleteRoomingPerDay = createAction(
  ActionTypes.DeleteRoomingPerDay,
  props<{ payload: DeleteRoomingPerDayActionPayload }>(),
);

/* This event is fired after deleting a RoomingPerDay successfully. */
export const DeleteRoomingPerDaySuccessful = createAction(
  ActionTypes.DeleteRoomingPerDaySuccessful,
  props<{ payload: DeleteRoomingPerDaySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a RoomingPerDay successfully. */
export const DeleteRoomingPerDayFailure = createAction(
  ActionTypes.DeleteRoomingPerDayFailure,
);

/* This event resets the RoomingPerDay state. */
export const ResetState = createAction(ActionTypes.ResetState);
